import { Button, Row } from 'antd';
import React from 'react';
import PageHeader from 'components/PageHeader';
import '../webhookListing.scss';

export const GenerateToken = ({ onRegenerate, onVisibleChange }) => {
  return (
    <div className="popover-wrappe generate-token-popover">
      <div className="generate-token-content">
        <PageHeader pageTitle={'Regenerate Webhook Secret Key?'} />
        <p>This will invalidate your current secret key and generate a new one.</p>
        <p>
          If you're using this key to verify webhook requests, please make sure that you update it
          in your system to avoid any disruptions.<b> This action cannot be undone.</b>
        </p>
      </div>
      <Row justify="end" className="generate-token-buttons">
        <Button className="large-btn grey-btn" onClick={onVisibleChange}>
          Cancel
        </Button>
        <Button
          className="large-btn secondary-btn"
          onClick={() => {
            onRegenerate();
            onVisibleChange();
          }}>
          Regenerate Key
        </Button>
      </Row>
    </div>
  );
};
